module.exports = __webpack_public_path__ + "img/421.74910904.png";